<template>
  <highcharts class="chart" :options="options" ref="highchart" />
</template>

<script>
import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { lineOptions } from '@/constants/chart-options';
import cloneDeep from 'lodash/cloneDeep';
import UserAccessHistApi from '@/api/settings/user/user-access-hist';

export default {
  name: 'WEventHistStackedColumnChart',
  data() {
    return {
      options: cloneDeep(lineOptions),
      userLoginChartData: [],
    };
  },
  computed: mapGetters(['analysisDateParams']),
  watch: {
    analysisDateParams: {
      handler() {
        this.loadData();
      },
    },
  },
  mounted() {
    this.options.xAxis = {
      type: 'datetime',
      labels: {
        format: '{value: %Y-%m-%d %H:%M:%S}',
        style: {
          color: '$chinagray',
          fontSize: '9px',
        },
      },
      crosshair: true,
    };
    // this.$store.dispatch('setInitialDatetimeRange', { type: 'fixed', value: 'today', label: '오늘' });
    this.$store.dispatch('setInitialDatetimeRange', { type: 'interval', interval: 'hour', value: 12 });
    this.$store.dispatch('setPlotLineDatetime', null);

    Object.assign(this.options.tooltip, {
      valueDecimals: 0,
      formatter() {
        return `${getDateToString(this.x)}<br/>접속자 수: <b>${this.y}명</b><br/>`;
      },
    });

    Object.assign(this.options.chart, { height: 140 });
  },
  methods: {
    /**
     * 사용자 접근 이력 차트 로드
     * @author Song
     */
    loadData() {
      const params = {
        startDatetime: this.analysisDateParams.startDatetime,
        endDatetime: this.analysisDateParams.endDatetime,
      };
      // 사용자 접속 이력 차트 데이터를 조회
      UserAccessHistApi.getUserLoginChartData(params).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.options.series = result;
          let maxLoginCount = EMPTY_TEXT;
          if (!isNil(result[0].maxLoginCount)) {
            maxLoginCount = result[0].maxLoginCount < 1 ? result[0].maxLoginCount : `${result[0].maxLoginCount} ( ${this.getDateFormatter(null, null, result[0].maxLoginDatetime)} )`;
          }
          this.$emit('update:maxLoginCount', maxLoginCount);
          this.$nextTick(() => {
            this.$emit('load-data');
          });
        }
      });
      UserAccessHistApi.getLongestSessionConnect(params).then((response) => {
        let sessionTimeString = EMPTY_TEXT;
        const result = response.data.data;
        if (response.data.success && !isNil(result)) {
          const sessionTime = isNil(result.sessionTimeString) ? EMPTY_TEXT : result.sessionTimeString;
          sessionTimeString = `${result.managerId} ( ${sessionTime} )`;
        }
        this.$emit('update:sessionTimeString', sessionTimeString);
      });
      UserAccessHistApi.getMostLoginUserCount(params).then((response) => {
        let mostLoginCount = EMPTY_TEXT;
        const result = response.data.data;
        if (response.data.success && !isNil(result)) {
          mostLoginCount = `${result.managerId} ( ${result.loginCount} 회)`;
        }
        this.$emit('update:mostLoginCount', mostLoginCount);
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserAccessHist/components/UserLoginLineChart.vue